import { createApp } from 'vue';
import Woff2ToTtfConverter from '@/Components/Woff2ToTtfConverter.vue';
import '@styles/app.css';

createApp(Woff2ToTtfConverter).mount('#woff2-to-ttf-converter');
